import { OrderState } from 'src/app/proxy/orders/enums';

export class SyncLog {
  id?: number;
  orderId: string;
  errorMessage: string;
  orderState: OrderState;
  createdAt: string;

  constructor(data?: Partial<SyncLog>) {
    this.id = data?.id;
    this.orderId = data?.orderId;
    this.errorMessage = data?.errorMessage ?? '';
    this.orderState = data?.orderState;
    this.createdAt = data?.createdAt ?? new Date().toISOString();
  }
}
